import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tab"
export default class extends Controller {
  static targets = ["tab", "panel"]

  // Action method for tab clicks
  switchTab(event) {
    event.preventDefault()
    const tabType = event.currentTarget.dataset.tabType
    if (tabType) {
      this.showTab(tabType)
    }
  }

  showTab(activeTabType) {
    this.tabTargets.forEach(tab => {
      const tabType = tab.dataset.tabType
      const isActive = tabType === activeTabType
      
      // Update tab button appearance
      tab.classList.toggle('btn-active', isActive)
      tab.classList.toggle('btn-outline', !isActive)
    })

    this.panelTargets.forEach(panel => {
      const tabType = panel.dataset.tabType
      const isActive = tabType === activeTabType
      
      // Show/hide panel
      panel.classList.toggle('hidden', !isActive)
      
      // Enable/disable inputs in panel
      const inputs = panel.querySelectorAll('input, textarea, select')
      inputs.forEach(input => {
        input.disabled = !isActive
      })
    })

    // Focus on the first input in the active panel
    this.focusActivePanel(activeTabType)
  }

  focusActivePanel(tabType) {
    setTimeout(() => {
      const activePanel = this.panelTargets.find(panel => 
        panel.dataset.tabType === tabType && !panel.classList.contains('hidden')
      )
      
      if (activePanel) {
        // Find any focusable input element
        const firstInput = activePanel.querySelector('input, textarea, select, [contenteditable="true"]')
        if (firstInput && !firstInput.disabled) {
          firstInput.focus()
        }
      }
    }, 100)
  }
}
